import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { ChartComponent } from '@app/shared/components/chart/base-chart/chart.component';
import { ChartData, ChartOptions, Plugin } from 'node_modules/chart.js/dist/types';
import { zoomControlsPlugin } from '@app/core/services/charts/plugins/zoom-controls.plugin';
import { scrollPanPlugin } from '@app/core/services/charts/plugins/scroll-pan.plugin';
import { customBarPinchZoomPlugin } from '@app/core/services/charts/plugins/custom-bar-pinch-zoom.plugin';
import { backgroundThresholdLinesPlugin } from '@app/core/services/charts/plugins/background-threshold-lines.plugin';
import { hoverBarBackgroundPlugin } from '@app/core/services/charts/plugins/hover-bar-background.plugin';
import { categoryAxisTicksPlugin } from '@app/core/services/charts/plugins/category-axis-ticks.plugin';

const BASE_PLUGINS = [
  zoomControlsPlugin,
  scrollPanPlugin,
  customBarPinchZoomPlugin,
  backgroundThresholdLinesPlugin,
  hoverBarBackgroundPlugin,
  categoryAxisTicksPlugin,
];

@Component({
  selector: 'gc-floating-popup-bar-chart-wrapper',
  imports: [ChartComponent],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './floating-popup-bar-chart-wrapper.component.html',
  styleUrl: './floating-popup-bar-chart-wrapper.component.scss',
  host: {
    class: 'flex flex-col',
  },
})
export class FloatingPopupBarChartWrapperComponent {
  public chartData = input.required<ChartData | undefined>();
  public chartOptions = input.required<ChartOptions | undefined>();
  public additionalPlugins = input<Plugin[]>([]);

  public get chartPlugins(): Plugin[] {
    return [...BASE_PLUGINS, ...this.additionalPlugins()];
  }
}
